/**
 * 解析JWT Token的载荷部分
 * @param {string} token JWT Token字符串
 * @returns {Object} 解析后的JWT payload对象
 */
export const parseJwtToken = (token) => {
  try {
    // 检查token是否存在
    if (!token) {
      // console.warn('尝试解析空token');
      return {};
    }
    
    // JWT Token 分为三部分：头部、载荷和签名，以点（.）分隔
    const parts = token.split('.');
    if (parts.length !== 3) {
      throw new Error('无效的token格式');
    }
    
    // 对base64进行解码，注意要处理URL安全的base64
    const payload = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const paddingLength = 4 - (payload.length % 4);
    const paddedPayload = paddingLength < 4 ? payload + '='.repeat(paddingLength) : payload;
    
    // 解析payload部分
    const decodedData = JSON.parse(atob(paddedPayload));
    return decodedData;
  } catch (error) {
    console.error('JWT Token解析失败：', error);
    return {};
  }
};

/**
 * 检查token是否过期
 * @param {string} token JWT Token字符串
 * @returns {boolean} 是否已过期
 */
export const isTokenExpired = (token) => {
  try {
    const payload = parseJwtToken(token);
    if (!payload.exp) {
      // 如果没有过期时间，假设没有过期
      return false;
    }
    
    // exp字段是Unix时间戳（秒），需要乘以1000转换为毫秒
    const expiry = payload.exp * 1000;
    return Date.now() >= expiry;
  } catch (error) {
    console.error('检查token过期失败：', error);
    // 如果解析出错，保守起见返回已过期
    return true;
  }
};

/**
 * 从token中获取特定字段
 * @param {string} token JWT Token字符串
 * @param {string} field 要获取的字段名
 * @returns {any} 字段值或undefined
 */
export const getTokenField = (token, field) => {
  try {
    const payload = parseJwtToken(token);
    return payload[field];
  } catch (error) {
    console.error(`从token获取${field}字段失败:`, error);
    return undefined;
  }
}; 